export interface BusinessWorkspace {
  revenue: number;
  directCost: number;
  variableCost: number;
  fixedCost: number;
  unitPrice: number;
  unitCost: number;
  unitOtherCost: number;
  feeRate: number;
  units: number;
  targetMarginRate: number;
  targetProfit: number;
  cashBalance: number;
  adSpend: number;
  attributedRevenue: number;
  grossMarginRate: number;
  updatedAt: string | null;
}

export const defaultBusinessWorkspace: BusinessWorkspace = {
  revenue: 0,
  directCost: 0,
  variableCost: 0,
  fixedCost: 0,
  unitPrice: 0,
  unitCost: 0,
  unitOtherCost: 0,
  feeRate: 0,
  units: 0,
  targetMarginRate: 0,
  targetProfit: 0,
  cashBalance: 0,
  adSpend: 0,
  attributedRevenue: 0,
  grossMarginRate: 0,
  updatedAt: null,
};
